export enum PricingTypeEnum {
    Highest = 1,
    Average = 2,
    CurrentCost = 3
}
